@if (hasAScreenStatusToDisplay()) {
  <side-panel-status-screens
    [sidePanelStatus]="sidePanel.status"
    (onRefresh)="fileIdFromExtension && fetchAllData(fileIdFromExtension)"
    (onSensitivity)="toggleDialog(DialogState.SECRET)"
  />
} @else {
  <div class="side-panel {{ lockedFileClass }}">
    <!-- HEADER -->
    <side-panel-title
      [title]="sidePanel.file?.name ?? ''"
      [ratings]="sidePanel.file?.ratings"
      [locked]="sidePanel.file?.is_locked"
      [loading]="sidePanel.loadingSections.includes(Sections.TITLE)"
    />

    @if (fileSequenceTemplatesMap.size > 0) {
      @for (sequence of sidePanel.fileSequenceInstances; track sequence) {
        @let template =
          fileSequenceTemplatesMap.get(sequence.file_sequence_template_id);

        @if (template) {
          <side-panel-file-sequence
            [template]="template"
            [instance]="sequence"
          />
        }
      }
    }

    <!-- LABELS -->
    <side-panel-labels
      [labels]="sidePanel.file?.labels"
      [loading]="sidePanel.loadingSections.includes(Sections.LABELS)"
      [locked]="sidePanel.file?.is_locked"
      [canSeeFlagged]="hasRightsToUnflag"
      (unlockFileEvent)="unlockFile()"
    />

    <!-- SPACING -->
    <div class="spacing-separator"></div>

    <!-- CREATORS / CONTRIBUTORS -->
    <side-panel-contributors
      [creator]="sidePanel.file?.created_by"
      [contributors]="sidePanel.file?.contributors"
    />

    <!-- DOCUMENT DESCRIPTION  -->
    <side-panel-description
      [description]="sidePanel.file?.description ?? ''"
      [loading]="sidePanel.loadingSections.includes(Sections.DESCRIPTION)"
    />

    <!-- TAGS -->
    <side-panel-tags
      [loading]="sidePanel.loadingSections.includes(Sections.PROPERTIES)"
      [confidentiality]="documentConfidentiality"
      [tags]="sidePanel.file?.tags"
      [hasRights]="hasRights"
      [locked]="sidePanel.file?.is_locked"
      [customProperties]="sidePanel.file?.labels"
      [suggestedProperties]="suggestedProperties"
      [properties]="sidePanel.customLabels"
      (editPropertiesCallback)="toggleDialog($event)"
      (ignoreSuggestedTagCallback)="ignoreSuggestedTag($event)"
      (ignoreSuggestedPropertyCallback)="ignoreSuggestedProperty($event)"
    />

    <!-- DOCUMENT RATING  -->
    <side-panel-ratings
      [display]="!isDocumentRatedByMe"
      [loading]="sidePanel.loadingSections.includes(Sections.RATINGS)"
      (addRatingEvent)="toggleDialog($event)"
    />

    <!-- WORKFLOW ACTIVITY -->
    <side-panel-activity
      [fileId]="sidePanel.file?.id"
      [workflowInstances]="sidePanel.workflowInstances"
      [loading]="sidePanel.loadingSections.includes(Sections.WORKFLOW)"
      [templates]="workflowTemplates.length"
      (startWorkflowEvent)="toggleDialog(DialogState.CUSTOMWORKFLOW)"
      (approveWorkflowStepEvent)="approveWorkflowStep($event)"
      (approveWorkflowStepWithConfidentiality)="
        toggleDialog(DialogState.WORKFLOW)
      "
      (rejectWorkflowEvent)="rejectWorkflow($event)"
      (acknowledgeWorkflowEvent)="acknowledgeWorkflowStep($event)"
      (drivePreview)="previewFile($event)"
    />

    <!-- WORKFLOW VERSIONS -->
    <side-panel-workflow-versions
      [workflowFileVersionHistory]="sidePanel.workflowFileVersionHistory"
      [file]="sidePanel.file"
      [loading]="
        sidePanel.loadingSections.includes(Sections.WORKFLOW_FILE_VERSIONS)
      "
    />
  </div>

  <!-- SIDEPANEL FOOTER-->
  <side-panel-footer
    [splitItems]="splitButtonItems"
    [likeButtonData]="likeButtonData"
    [loading]="
      sidePanel.loadingSections.includes(Sections.LIKE) ||
      sidePanel.loadingSections.includes(Sections.RATINGS)
    "
    (addRatingEvent)="toggleDialog($event)"
  />
}

<!-- DIALOGS -->
<side-panel-dialogs
  [dialog]="dialogs[dialogToDisplay].component"
  [injector]="dialogs[dialogToDisplay].injector"
  [visible]="dialogToDisplay !== DialogState.NONE"
  [header]="dialogsHeader[dialogToDisplay]"
  [isLoading]="sidePanel.status === sidePanelStatus.LOADING"
  (hideDialogCallback)="toggleDialog($event)"
/>

<!-- LOCKED FILE -->
@if (
  sidePanel.file?.is_locked &&
  sidePanel.status !== sidePanelStatus.LOADING &&
  lockedToasterVisible
) {
  @if (hasRights) {
    <div class="bottom-action" (mousedown)="unlockFile()">
      <span>This document is locked</span>
      <span class="white-link">Unlock to edit</span>
    </div>
  } @else {
    <div class="bottom-action bottom-central">
      <span>This document is locked</span>
    </div>
  }
}
